import Hammer from 'hammerjs';

class TermsAndConditionsModal {
  constructor(element, shouldOpen) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.shouldOpen = shouldOpen;
    // get the modal on the page, by default element should be the contents
    this.modal = element;

    if (this.modal) {
      this.init();
    }
  }

  init() {
    if (this.shouldOpen) {
      MicroModal.show(this.modal.id);
    }

    this.termsAndConditionsCheckbox = this.modal.querySelector('#terms-and-conditions');
    this.submitButton = this.modal.querySelector('#terms-button');
    this.form = this.modal.querySelector('form');

    console.log('Terms and conditions: ', this.termsAndConditionsCheckbox);
    console.log('Submit Button: ', this.submitButton);
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        MicroModal.close(this.modal.id);
      });

      if (this.termsAndConditionsCheckbox && this.submitButton) {
        this.termsAndConditionsCheckbox.addEventListener('click', (e) => {
          console.log('Is checked? ', this.termsAndConditionsCheckbox.checked);
          this.submitButton.disabled = !this.termsAndConditionsCheckbox.checked;
        });
      }
    }
    this.handle = this.modal.querySelector('.modal__handle');
    if (this.handle) {
      console.log('Has a handle');
      this.initHandle();
    }
  }

  initHandle() {
    if (this.handle) {
      this.hammer = new Hammer(this.handle);

      this.hammer
        .get('swipe')
        .set({ direction: Hammer.DIRECTION_VERTICAL });

      this.hammer.on('swipedown', this.closeModal.bind(this));
    }
  }

  closeModal() {
    MicroModal.close(this.modal.id);
  }
}

export default TermsAndConditionsModal;
